import React from 'react';
import { cn } from '../../utils';

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md';
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({ 
  className, 
  variant = 'default', 
  size = 'md', 
  children, 
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full border';
  
  const variants = {
    default: 'theme-bg-secondary theme-text-secondary theme-border-primary',
    success: 'theme-green-bg theme-green-text border-emerald-200',
    warning: 'theme-yellow-bg theme-yellow-text border-amber-200',
    danger: 'theme-red-bg theme-red-text border-red-200',
    info: 'theme-blue-bg theme-blue-text border-blue-200',
  };
  
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  return (
    <div
      className={cn(baseClasses, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default Badge; 